(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var openDetails = document.querySelectorAll('.mega-menu__details[open]');
    openDetails.forEach(function (details) {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  });

  document.querySelectorAll('.mega-menu__details').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (details.open) {
        document.querySelectorAll('.mega-menu__details[open]').forEach(function (other) {
          if (other !== details) other.removeAttribute('open');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
